export default class Chat
{
    
    constructor( core )
    {
        
        if ( !Chat.instance ) {
            
            this.logger = core.getLogger()
            this.client = core.getClient()
            this.store = core.getStore()
            this.eventManager = core.getEventManager()
            
            this.states = {
                room:     false,
                active:   false,
                lastTick: Date.now()
            }
            
            this.timer = null
            this.interval = 2000
            
            this.eventManager.add( 'on-chat-message', ( payload ) =>
            {
                this.handleChatMessage( payload )
            } )
            
            Chat.instance = this
            
        }
        return Chat.instance
        
    }
    
    ping()
    {
        this.client.request( {
                method: 'chat.ping'
            } )
            .then( () =>
            {
            } )
    }
    
    enter( idRoom )
    {
        return new Promise( ( resolve, reject ) =>
        {
            
            this.client.request( {
                method: 'chat.enter',
                idRoom: idRoom
            } ).then( () =>
            {
                
                this.states.room = idRoom
                this.states.active = true
                
                this.timer = setInterval( () =>
                {
                    this.ping()
                }, this.interval )
                return resolve()
                
            } ).catch( e =>
            {
                console.error( e )
                return reject()
            } )
            
        } )
    }
    
    leave( idRoom )
    {
        return new Promise( ( resolve, reject ) =>
        {
            
            clearInterval( this.timer )
            
            this.client.request( {
                method: 'chat.leave',
                idRoom: idRoom
            } ).then( () =>
            {
                
                this.states.room = false
                this.states.active = false
                
                return resolve()
                
            } ).catch( () =>
            {
                return reject()
            } )
            
        } )
    }
    
    handleChatMessage( payload )
    {
        
        switch ( payload.type ) {
            case 'enter':
                payload.text = 'kommt herein'
                break
            case 'leave':
                payload.text = 'hat den Raum verlassen'
                break
            case 'return':
                payload.type = 'away'
                payload.text = 'meldet sich zurück: ' + payload.text
                break
        }
        
        let parsed = {
            timestamp: new Date( payload.datetimeSent ),
            idSender:  payload.idUser,
            idRoom:    payload.idRoom,
            username:  payload.username,
            color:     payload.color,
            type:      payload.type,
            text:      payload.text,
            prepend:   payload.prepend
        }
        
        this.eventManager.dispatch( 'on-chat-out', parsed )
        
    }
    
    sendMessage( message )
    {
        message.method = 'chat.chatMessage'
        this.client.request( message )
            .then( () =>
            {
            
            } )
            .catch( () =>
            {
                console.log( 'kaputt' )
            } )
    }
}